import React, { useState, useEffect, useRef } from 'react';
import styles from './InfoBanner.module.css';

const DISMISSED_KEY = 'infoBannerDismissed';

const InfoBanner = () => {
  const [isAnimated, setIsAnimated] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const bannerRef = useRef(null);

  // Fonction pour vérifier si l'utilisateur est admin
  const isAdmin = () => {
    return userInfo && userInfo.roles && userInfo.roles.includes('ROLE_ADMIN');
  };
  
  // Vous pouvez facilement modifier ce texte ici
  const bannerText = "Nouveaux sites disponibles : Whatnot et Opla, version bêta. Vous pouvez prendre l'abonnement, il sera remboursé. Merci de vos retours à <a href='mailto:contact@flowdino.com' style='text-decoration: underline; color: white;'>contact@flowdino.com</a><br />";
  // const bannerText = "Vinted met en place un nouveau système de tailles, pensez à vérifier votre configuration <a href='/docs/sales-config#vinted-size-version' style='text-decoration: underline; color: white;'>En savoir plus</a>";
  //
  // const bannerText = "⚠️ Les problèmes de publication sur Vinted et Leboncoin sont résolus avec la nouvelle version de l'extenstion (1.2.41)";
  // const bannerText = "Un problème sur l'hébergement Hostinger bloque les accès au service, la résolution est en cours";
  // Nouvelle fonctionnalité : Planifiez vos tâches pour qu'elles s'exécutent toutes seules <a href='https://www.flowdino.com/docs/automation' style='text-decoration: underline; color: white;'>En savoir plus</a>

  // Alternative : Extension en cours de déploiement
  // const bannerText = "Extension en cours de déploiement";
  
  // Le bandeau reste fermé tant que le message n'a pas changé
  const [isVisible, setIsVisible] = useState(() => {
    try {
      return localStorage.getItem(DISMISSED_KEY) !== bannerText;
    } catch {
      return true;
    }
  });

  const handleClose = () => {
    setIsVisible(false);
    try {
      localStorage.setItem(DISMISSED_KEY, bannerText);
    } catch {
      // localStorage indisponible : fermeture pour la session uniquement
    }
  };

  useEffect(() => {
    // Récupérer les informations utilisateur depuis localStorage
    const storedUserInfo = localStorage.getItem('userInfo');
    if (storedUserInfo) {
      setUserInfo(JSON.parse(storedUserInfo));
    }
  }, []);

  useEffect(() => {
    // Animation d'entrée avec délai
    const timer = setTimeout(() => {
      setIsAnimated(true);
    }, 500);
    
    return () => clearTimeout(timer);
  }, []);
  
  // Expose la hauteur du bandeau pour que les éléments flottants (bouton Aide) se placent au-dessus
  const shown = isVisible && !isAdmin();
  useEffect(() => {
    const root = document.documentElement;
    const el = bannerRef.current;
    if (!shown || !el) {
      root.style.removeProperty('--info-banner-height');
      return undefined;
    }
    const update = () => root.style.setProperty('--info-banner-height', `${el.offsetHeight}px`);
    update();
    const observer = new ResizeObserver(update);
    observer.observe(el);
    return () => {
      observer.disconnect();
      root.style.removeProperty('--info-banner-height');
    };
  }, [shown]);

  // Ne pas afficher le bandeau si l'utilisateur est admin ou si le bandeau est fermé
  if (!isVisible || isAdmin()) {
    return null;
  }

  return (
    <div ref={bannerRef} className={`${styles.infoBanner} ${isAnimated ? styles.animated : ''}`}>
      <div className={styles.container}>
        <div className={styles.content}>
          <span className={styles.icon}>⚠️</span>
          <span 
            className={styles.text}
            dangerouslySetInnerHTML={{ __html: bannerText }}
          />
        </div>
        <button 
          className={styles.closeButton}
          onClick={handleClose}
          aria-label="Fermer le bandeau"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default InfoBanner;
